import SubCategoryLinksList from './subCategoryLinksList'

export default SubCategoryLinksList
